import React from "react";
import { useT } from "@transifex/react";
import { useQuestionnaire } from "../../../context/questionnaire";
import {
  ContentCard,
  FixedNavBar,
  NavRow,
  NavButton,
  QuestionTitle,
} from "../../../layouts/questionnaire-layout/styles";
import styled from "styled-components";
import { formatAnswer, getAnswerKey } from "../../../helpers/questionnaire-helpers";

const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SummaryItem = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`;

const SummaryLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #6b6b76;
  margin-bottom: 4px;
`;

const SummaryValue = styled.div`
  font-size: 16px;
  color: #4a4d5e;
`;

const SummaryPage: React.FC = () => {
  const t = useT();
  const {
    questions,
    answers,
    visiblePages,
    goToPage,
    submitQuestionnaire,
    isSubmitting,
  } = useQuestionnaire();

  const answeredQuestions = Object.entries(answers).filter(
    ([, answer]) => answer.isValid
  );

  return (
    <>
      <ContentCard>
        <QuestionTitle>{t("Review Your Answers")}</QuestionTitle>
        <SummaryList>
          {answeredQuestions.map(([name, answer]) => {
            const formatted = formatAnswer(answer);
            const displayValue =
              typeof formatted === "object"
                ? JSON.stringify(formatted)
                : String(formatted ?? "");

            return (
              <SummaryItem key={name}>
                <SummaryLabel>
                  {answer.question.data.lead ||
                    answer.question.data.description ||
                    answer.question.data.name}
                </SummaryLabel>
                <SummaryValue>{displayValue}</SummaryValue>
              </SummaryItem>
            );
          })}
        </SummaryList>
      </ContentCard>
      <FixedNavBar>
        <NavRow>
          <NavButton
            variant="secondary"
            onClick={() => goToPage(visiblePages.length - 1)}
          >
            {t("Back")}
          </NavButton>
          <NavButton
            variant="primary"
            onClick={submitQuestionnaire}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("Submitting...") : t("Submit")}
          </NavButton>
        </NavRow>
      </FixedNavBar>
    </>
  );
};

export default SummaryPage;
